import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../api";

export default function News() {
  const qc = useQueryClient();
  const { data: liste = [], isLoading } = useQuery({ queryKey: ["admin-news"], queryFn: async () => (await api.get("/admin/news")).data });
  const [d, setD] = useState(null);

  const kaydet = async () => {
    if (d.id) await api.put(`/admin/news/${d.id}`, d);
    else await api.post("/admin/news", d);
    qc.invalidateQueries({ queryKey: ["admin-news"] }); qc.invalidateQueries({ queryKey: ["news"] });
    setD(null); toast.success("Kaydedildi");
  };
  const sil = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/news/${id}`); qc.invalidateQueries({ queryKey: ["admin-news"] }); };

  if (isLoading) return <p className="veri">Yükleniyor…</p>;
  if (d) return (
    <div className="a-form">
      <h1 style={{ fontFamily: "var(--display)", fontSize: 24 }}>{d.id ? "Haberi düzenle" : "Yeni haber"}</h1>
      <div><label>Başlık</label><input value={d.baslik || ""} onChange={(e) => setD({ ...d, baslik: e.target.value })} data-testid="haber-baslik" /></div>
      <div><label>Özet</label><input value={d.ozet || ""} onChange={(e) => setD({ ...d, ozet: e.target.value })} /></div>
      <div><label>İçerik</label><textarea rows={5} value={d.icerik || ""} onChange={(e) => setD({ ...d, icerik: e.target.value })} /></div>
      <div className="grid2">
        <div><label>Tarih (yayın)</label><input type="date" value={d.tarih || ""} onChange={(e) => setD({ ...d, tarih: e.target.value })} /></div>
        <label className="a-satir" style={{ marginTop: 22 }}><input type="checkbox" checked={!!d.yayinda} onChange={(e) => setD({ ...d, yayinda: e.target.checked })} data-testid="haber-yayinda" /> Yayında</label>
      </div>
      <div className="a-satir"><button className="a-btn bal" onClick={kaydet} data-testid="haber-kaydet">Kaydet</button><button className="a-btn hayalet" onClick={() => setD(null)}>İptal</button></div>
    </div>
  );
  return (
    <div>
      <div className="a-satir" style={{ justifyContent: "space-between", marginBottom: 16 }}>
        <h1 style={{ fontFamily: "var(--display)", fontSize: 26 }}>Haberler</h1>
        <button className="a-btn bal" onClick={() => setD({ baslik: "", ozet: "", icerik: "", tarih: new Date().toISOString().slice(0, 10), yayinda: false })} data-testid="haber-yeni">+ Yeni haber</button>
      </div>
      {liste.length === 0 ? <div className="a-bos">Henüz haber eklenmedi.</div> : (
        <table className="a-tablo">
          <thead><tr><th>Başlık</th><th>Tarih</th><th>Durum</th><th></th></tr></thead>
          <tbody>{liste.map((n) => (<tr key={n.id}><td>{n.baslik}</td><td className="sayi">{n.tarih}</td><td>{n.yayinda ? "Yayında" : "Taslak"}</td><td className="a-satir"><button className="a-btn hayalet kucuk" onClick={() => setD(n)}>Düzenle</button><button className="a-btn hayalet kucuk" onClick={() => sil(n.id)}>Sil</button></td></tr>))}</tbody>
        </table>
      )}
    </div>
  );
}
